<template>
  <a-modal
      :footer="footer"
      :visible="isVisible"
      @cancel="$emit('cancel', $event)"
      dialogClass="transparent"
      wrapClassName="custom-modal"
      :dialogStyle="{
        padding:0,
        backgroundColor: 'transparent',
      }"
      :bodyStyle="{
        padding:0,
        backgroundColor: 'transparent',
        marginBottom: 100
      }"
      ref="modal"
      v-bind="$attrs"
  >
    <template v-if="!showCancel" #closeIcon></template>
    <slot></slot>
  </a-modal>
</template>

<script>
export default {
  emits: ['cancel', 'input'],
  name: "Modal.vue",
  props: {
    value: {
      type: Boolean,
      required: false,
      default: null,
    },
    visible: {
      type: Boolean,
      required: false,
      default: false,
    },
    showCancel: {
      type: Boolean,
      required: false,
      default: false,
    },
    footer: {
      type: Boolean,
      required: false,
      default: null,
    },
  },
  methods: {
    close() {
      this.$refs.modal.close();
    }
  },
  computed:{
    isVisible(){
      return this.value === null ? this.visible : this.value;
    }
  },
  watch:{
    visible(newV){
      const html = document.getElementsByTagName('html')[0];
      html.style.overflowY = newV ? 'hidden' : 'scroll';
    },
    value(newV){
      const html = document.getElementsByTagName('html')[0];
      html.style.overflowY = newV ? 'hidden' : 'scroll';
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.transparent {
  background-color: transparent;
}
</style>

<style lang="scss">
@import "~@/_default.scss";
.custom-modal {
  .ant-modal-content {
    background-color: transparent;
    border-radius: 0;
  }
}
</style>
